(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["momount-luminaire-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ml-section]').forEach((section)=>{
  const media=[...section.querySelectorAll('[data-ml-media]')];
  const thumbs=[...section.querySelectorAll('[data-ml-thumb]')];
  let active=0;
  const show=(index)=>{
    if(!media.length)return;
    active=(index+media.length)%media.length;
    media.forEach((item,i)=>{item.hidden=i!==active;item.classList.toggle('is-active',i===active)});
    thumbs.forEach((item,i)=>{item.classList.toggle('is-active',i===active);item.setAttribute('aria-selected',i===active?'true':'false')});
    thumbs[active]?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
  };
  thumbs.forEach((thumb)=>thumb.addEventListener('click',()=>show(Number(thumb.dataset.mlThumb))));
  section.querySelector('[data-ml-prev]')?.addEventListener('click',()=>show(active-1));
  section.querySelector('[data-ml-next]')?.addEventListener('click',()=>show(active+1));

  const source=[...section.querySelectorAll('[data-ml-variant-source] option')];
  const groups=[...section.querySelectorAll('[data-ml-option-index]')];
  const updateVariant=()=>{
    const values=groups.map((group)=>group.querySelector('[data-ml-option]:checked')?.value);
    const option=source.find((item)=>item.dataset.options.split('||').every((value,index)=>value===values[index]));
    groups.forEach((group)=>{
      const checked=group.querySelector('[data-ml-option]:checked');
      group.querySelector('[data-ml-option-value]').textContent=checked?.value||'';
      group.querySelectorAll('.ml__chip').forEach((chip)=>chip.classList.toggle('is-selected',chip.contains(checked)));
    });
    const input=section.querySelector('[data-ml-variant-id]');
    const submit=section.querySelector('[data-ml-submit]');
    const mobileSubmit=section.querySelector('[data-ml-mobile-submit]');
    if(!option){
      submit.disabled=true;
      if(mobileSubmit)mobileSubmit.disabled=true;
      return;
    }
    input.value=option.value;
    section.querySelector('[data-ml-price]').textContent=option.dataset.price;
    const mobilePrice=section.querySelector('[data-ml-mobile-price]');
    if(mobilePrice)mobilePrice.textContent=option.dataset.price;
    const compare=section.querySelector('[data-ml-compare]');
    compare.textContent=option.dataset.compare||'';
    compare.classList.toggle('is-hidden',!option.dataset.compare);
    section.querySelector('[data-ml-price-row]')?.classList.toggle('is-sale',Boolean(option.dataset.compare));
    const available=option.dataset.available==='true';
    submit.disabled=!available;
    if(mobileSubmit)mobileSubmit.disabled=!available;
  };
  section.querySelectorAll('[data-ml-option]').forEach((input)=>input.addEventListener('change',updateVariant));

  const mobileBar=section.querySelector('[data-ml-mobile-bar]');
  const mobileTrigger=section.querySelector('[data-ml-mobile-trigger]');
  let mobileFrame;
  const updateMobileBar=()=>{
    mobileFrame=undefined;
    const visible=window.matchMedia('(max-width:699px)').matches&&mobileTrigger&&mobileTrigger.getBoundingClientRect().bottom<=0;
    mobileBar?.classList.toggle('is-visible',Boolean(visible));
    mobileBar?.setAttribute('aria-hidden',visible?'false':'true');
  };
  const queueMobileBarUpdate=()=>{
    if(mobileFrame)return;
    mobileFrame=requestAnimationFrame(updateMobileBar);
  };
  window.addEventListener('scroll',queueMobileBarUpdate,{passive:true});
  window.addEventListener('resize',queueMobileBarUpdate);
  queueMobileBarUpdate();

  const quantity=section.querySelector('[data-ml-quantity]');
  section.querySelector('[data-ml-quantity-minus]')?.addEventListener('click',()=>{quantity.value=Math.max(1,Number(quantity.value||1)-1)});
  section.querySelector('[data-ml-quantity-plus]')?.addEventListener('click',()=>{quantity.value=Math.max(1,Number(quantity.value||1)+1)});

  const dialog=section.querySelector('[data-ml-dialog]');
  const dialogImage=section.querySelector('[data-ml-dialog-image]');
  section.querySelector('[data-ml-zoom]')?.addEventListener('click',()=>{
    const current=media[active]?.querySelector('img');
    if(current&&dialogImage)dialogImage.src=current.currentSrc||current.src;
    dialog?.showModal();
  });
  section.querySelector('[data-ml-close]')?.addEventListener('click',()=>dialog?.close());
  dialog?.addEventListener('click',(event)=>{if(event.target===dialog)dialog.close()});

  const recommendations=section.querySelector('[data-ml-recommendations]');
  if(recommendations&&!recommendations.children.length){
    fetch(recommendations.dataset.url)
      .then((response)=>response.text())
      .then((html)=>{
        const parsed=new DOMParser().parseFromString(html,'text/html');
        const replacement=parsed.querySelector('[data-ml-recommendations]');
        if(replacement?.children.length)recommendations.innerHTML=replacement.innerHTML;
      })
      .catch(()=>{});
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["momount-oaks-mushroom-lamp"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-onp-section]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  const media = [...root.querySelectorAll('[data-onp-media]')];
  const thumbs = [...root.querySelectorAll('[data-onp-thumb]')];
  let activeMedia = media.findIndex((item) => !item.hidden);
  if (activeMedia < 0) activeMedia = 0;
  const showMedia = (id) => {
    let index = media.findIndex((item) => item.dataset.onpMedia === String(id));
    if (index < 0) index = 0;
    activeMedia = index;
    media.forEach((item, itemIndex) => {
      item.hidden = itemIndex !== index;
      item.classList.toggle('is-active', itemIndex === index);
    });
    thumbs.forEach((thumb) => {
      const selected = thumb.dataset.onpThumb === media[index]?.dataset.onpMedia;
      thumb.classList.toggle('is-active', selected);
      thumb.setAttribute('aria-selected', selected ? 'true' : 'false');
      if (selected) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  };
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.onpThumb)));
  root.querySelector('[data-onp-previous]')?.addEventListener('click', () => showMedia(media[(activeMedia - 1 + media.length) % media.length]?.dataset.onpMedia));
  root.querySelector('[data-onp-next]')?.addEventListener('click', () => showMedia(media[(activeMedia + 1) % media.length]?.dataset.onpMedia));

  const optionGroups = [...root.querySelectorAll('[data-onp-option]')];
  const variantSource = root.querySelector('[data-onp-variant-source]');
  const variantInput = root.querySelector('[data-onp-variant-id]');
  const price = root.querySelector('[data-onp-price]');
  const compare = root.querySelector('[data-onp-compare]');
  const save = root.querySelector('[data-onp-save]');
  const add = root.querySelector('[data-onp-add]');
  const addLabel = root.querySelector('[data-onp-add-label]');
  const mobileAdd = root.querySelector('[data-onp-mobile-add]');
  const mobilePrice = root.querySelector('[data-onp-mobile-price]');
  const syncVariant = () => {
    const values = optionGroups.map((group) => group.querySelector('[data-onp-option-input]:checked')?.value || '');
    const variant = [...variantSource.options].find((option) => option.dataset.options.split('||').every((value, index) => value === values[index]));
    if (!variant) return;
    variantInput.value = variant.value;
    variantSource.value = variant.value;
    price.textContent = variant.dataset.price;
    mobilePrice.textContent = variant.dataset.price;
    const hasCompare = variant.dataset.compare && variant.dataset.compare !== variant.dataset.price;
    compare.textContent = variant.dataset.compare;
    compare.classList.toggle('is-hidden', !hasCompare);
    save.textContent = `Économisez ${variant.dataset.savings}`;
    save.classList.toggle('is-hidden', !hasCompare);
    const available = variant.dataset.available === 'true';
    add.disabled = !available;
    mobileAdd.disabled = !available;
    addLabel.textContent = available ? 'Ajouter au panier' : 'Épuisé';
    mobileAdd.textContent = available ? 'Ajouter au panier' : 'Épuisé';
    if (variant.dataset.media) showMedia(variant.dataset.media);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.value);
    window.history.replaceState({}, '', url);
  };
  optionGroups.forEach((group) => {
    group.querySelectorAll('[data-onp-option-input]').forEach((input) => input.addEventListener('change', () => {
      group.querySelectorAll('.onp__swatch').forEach((label) => label.classList.toggle('is-selected', label.contains(input)));
      group.querySelector('[data-onp-option-label]').textContent = input.value;
      syncVariant();
    }));
  });

  const recommendations = root.querySelector('[data-onp-recommendations]');
  if (recommendations && !recommendations.querySelector('.onp__recommendations-grid')) {
    fetch(recommendations.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const replacement = parsed.querySelector('[data-onp-recommendations]');
        if (replacement) recommendations.replaceWith(replacement);
      })
      .catch(() => {});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["momount-premium-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mp-section]').forEach((section)=>{
  const media=[...section.querySelectorAll('[data-mp-media]')];
  const thumbs=[...section.querySelectorAll('[data-mp-thumb]')];
  let active=0;
  const show=(index)=>{
    if(!media.length)return;
    active=(index+media.length)%media.length;
    media.forEach((item,i)=>{item.hidden=i!==active;item.classList.toggle('is-active',i===active)});
    thumbs.forEach((item,i)=>{item.classList.toggle('is-active',i===active);item.setAttribute('aria-selected',i===active?'true':'false')});
    thumbs[active]?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
  };
  thumbs.forEach((thumb)=>thumb.addEventListener('click',()=>show(Number(thumb.dataset.mpThumb))));
  section.querySelector('[data-mp-prev]')?.addEventListener('click',()=>show(active-1));
  section.querySelector('[data-mp-next]')?.addEventListener('click',()=>show(active+1));
  const select=section.querySelector('[data-mp-variant]');
  if(select)select.addEventListener('change',()=>{
    const option=select.options[select.selectedIndex];
    section.querySelector('[data-mp-price]').textContent=option.dataset.price;
    const compare=section.querySelector('[data-mp-compare]');
    if(compare)compare.textContent=option.dataset.compare||'';
    const mobile=section.querySelector('[data-mp-mobile-price]');
    if(mobile)mobile.textContent=option.dataset.price;
    const button=section.querySelector('[data-mp-submit]');
    button.disabled=option.dataset.available!=='true';
    section.querySelector('[data-mp-submit-label]').textContent=button.disabled?'Ausverkauft':'Jetzt auswählen';
  });
  const mobileBar=section.querySelector('[data-mp-mobile-bar]');
  const mobileTrigger=section.querySelector('[data-mp-mobile-trigger]');
  let mobileFrame;
  const updateMobileBar=()=>{
    mobileFrame=undefined;
    const visible=window.matchMedia('(max-width:699px)').matches&&mobileTrigger&&mobileTrigger.getBoundingClientRect().bottom<=0;
    mobileBar?.classList.toggle('is-visible',Boolean(visible));
    mobileBar?.setAttribute('aria-hidden',visible?'false':'true');
  };
  const queueMobileBarUpdate=()=>{
    if(mobileFrame)return;
    mobileFrame=requestAnimationFrame(updateMobileBar);
  };
  window.addEventListener('scroll',queueMobileBarUpdate,{passive:true});
  window.addEventListener('resize',queueMobileBarUpdate);
  queueMobileBarUpdate();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["momount-water-flosser-v2"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mwf2]').forEach((section)=>{
  const slides=[...section.querySelectorAll('[data-mwf2-slide]')];
  const thumbs=[...section.querySelectorAll('[data-mwf2-thumb]')];
  const dots=[...section.querySelectorAll('[data-mwf2-dot]')];
  let active=0;
  const show=(index)=>{
    if(!slides.length)return;
    active=(index+slides.length)%slides.length;
    slides.forEach((slide,i)=>slide.hidden=i!==active);
    [...thumbs,...dots].forEach((item)=>item.classList.toggle('is-active',Number(item.dataset.mwf2Thumb??item.dataset.mwf2Dot)===active));
    thumbs[active]?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
  };
  thumbs.forEach((item)=>item.addEventListener('click',()=>show(Number(item.dataset.mwf2Thumb))));
  dots.forEach((item)=>item.addEventListener('click',()=>show(Number(item.dataset.mwf2Dot))));
  section.querySelector('[data-mwf2-prev]')?.addEventListener('click',()=>show(active-1));
  section.querySelector('[data-mwf2-next]')?.addEventListener('click',()=>show(active+1));
  section.querySelector('[data-mwf2-gallery-jump]')?.addEventListener('click',()=>{show(Number(section.querySelector('[data-mwf2-gallery-jump]').dataset.mwf2GalleryJump));section.querySelector('.mwf2__stage')?.scrollIntoView({behavior:'smooth',block:'center'})});
  const qty=section.querySelector('.mwf2__qty input');
  section.querySelector('[data-mwf2-minus]')?.addEventListener('click',()=>qty.value=Math.max(1,Number(qty.value||1)-1));
  section.querySelector('[data-mwf2-plus]')?.addEventListener('click',()=>qty.value=Math.max(1,Number(qty.value||1)+1));
  section.querySelectorAll('.mom-acc__btn').forEach((button)=>button.addEventListener('click',()=>{
    const panel=button.closest('.mom-acc__item').querySelector('.mom-acc__panel');
    const open=button.getAttribute('aria-expanded')==='true';
    button.setAttribute('aria-expanded',String(!open));button.querySelector('.mwf2__acc-sign').textContent=open?'+':'−';panel.hidden=open;
  }));
  const bar=section.querySelector('[data-mwf2-mobile]');
  const buy=section.querySelector('.mwf2__buy');
  const footer=document.querySelector('footer');
  if(bar&&buy){
    const update=()=>{const b=buy.getBoundingClientRect();const f=footer?.getBoundingClientRect();bar.classList.toggle('is-visible',b.bottom<0&&(!f||f.top>window.innerHeight))};
    window.addEventListener('scroll',update,{passive:true});update();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["momount-water-flosser"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mwf]').forEach((section)=>{
  const slides=[...section.querySelectorAll('[data-slide]')];
  const thumbs=[...section.querySelectorAll('[data-thumb]')];
  let active=0;
  const show=(index)=>{
    if(!slides.length)return;
    active=(index+slides.length)%slides.length;
    slides.forEach((slide,i)=>slide.hidden=i!==active);
    thumbs.forEach((thumb,i)=>thumb.classList.toggle('is-active',i===active));
    thumbs[active]?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
  };
  thumbs.forEach((thumb)=>thumb.addEventListener('click',()=>show(Number(thumb.dataset.thumb))));
  section.querySelector('[data-prev]')?.addEventListener('click',()=>show(active-1));
  section.querySelector('[data-next]')?.addEventListener('click',()=>show(active+1));
  const input=section.querySelector('.mwf__quantity input');
  section.querySelector('[data-qty-minus]')?.addEventListener('click',()=>input.value=Math.max(1,Number(input.value||1)-1));
  section.querySelector('[data-qty-plus]')?.addEventListener('click',()=>input.value=Math.max(1,Number(input.value||1)+1));
  section.querySelectorAll('.mom-acc__btn').forEach((button)=>button.addEventListener('click',()=>{
    const item=button.closest('.mom-acc__item');
    const panel=item.querySelector('.mom-acc__panel');
    const open=button.getAttribute('aria-expanded')==='true';
    button.setAttribute('aria-expanded',String(!open));
    button.querySelector('span').textContent=open?'+':'−';
    panel.hidden=open;
    item.classList.toggle('is-open',!open);
  }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vapora-pro-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vapora-section]').forEach((section) => {
    const thumbs = section.querySelectorAll('[data-vp-thumb]');
    const media = section.querySelectorAll('[data-vp-media]');
    const previous = section.querySelector('[data-vp-previous]');
    const next = section.querySelector('[data-vp-next]');
    let activeIndex = 0;

    const showMedia = (index) => {
      activeIndex = (index + media.length) % media.length;
      thumbs.forEach((item, itemIndex) => {
        const isActive = itemIndex === activeIndex;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      media.forEach((item, itemIndex) => {
        const isActive = itemIndex === activeIndex;
        item.classList.toggle('is-active', isActive);
        item.hidden = !isActive;
      });
      if (thumbs[activeIndex]) {
        const thumbnailRail = thumbs[activeIndex].parentElement;
        const centeredOffset = thumbs[activeIndex].offsetLeft
          - (thumbnailRail.clientWidth - thumbs[activeIndex].offsetWidth) / 2;
        thumbnailRail.scrollTo({ left: centeredOffset, behavior: 'smooth' });
      }
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        showMedia(Number(thumb.dataset.vpThumb));
      });
    });

    if (previous) {
      previous.addEventListener('click', () => showMedia(activeIndex - 1));
    }
    if (next) {
      next.addEventListener('click', () => showMedia(activeIndex + 1));
    }

    const mobileBar = section.querySelector('[data-vp-mobile-bar]');
    const mobileAdd = section.querySelector('[data-vp-mobile-add]');
    const gallery = section.querySelector('.vp__gallery');
    const stage = section.querySelector('.vp__stage');
    const productForm = section.querySelector('.vp__form');
    const mobileViewport = window.matchMedia('(max-width: 699px)');
    let mobileBarTicking = false;

    const updateMobileBar = () => {
      mobileBarTicking = false;
      if (!mobileBar || !gallery || !stage || !mobileViewport.matches) {
        mobileBar?.classList.remove('is-visible');
        mobileBar?.setAttribute('aria-hidden', 'true');
        return;
      }

      const galleryTop = gallery.getBoundingClientRect().top + window.scrollY;
      const triggerPoint = galleryTop + stage.offsetHeight;
      const shouldShow = window.scrollY >= triggerPoint;
      mobileBar.classList.toggle('is-visible', shouldShow);
      mobileBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    const requestMobileBarUpdate = () => {
      if (mobileBarTicking) return;
      mobileBarTicking = true;
      window.requestAnimationFrame(updateMobileBar);
    };

    window.addEventListener('scroll', requestMobileBarUpdate, { passive: true });
    window.addEventListener('resize', requestMobileBarUpdate);
    mobileViewport.addEventListener?.('change', requestMobileBarUpdate);
    requestMobileBarUpdate();

    if (mobileAdd && productForm) {
      mobileAdd.addEventListener('click', async () => {
        if (mobileAdd.disabled) return;

        const originalLabel = mobileAdd.textContent;
        const cartDrawer = document.querySelector('cart-drawer');
        const drawerSection = cartDrawer?.closest('.shopify-section');
        const drawerSectionId = drawerSection?.id?.replace('shopify-section-', '');
        const formData = new FormData(productForm);
        const requestedSections = [drawerSectionId, 'cart-icon-bubble'].filter(Boolean);

        if (requestedSections.length) {
          formData.set('sections', requestedSections.join(','));
          formData.set('sections_url', window.location.pathname);
        }

        mobileAdd.disabled = true;
        mobileAdd.textContent = 'Wird hinzugefügt…';

        try {
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });
          const result = await response.json();

          if (!response.ok || result.status) {
            throw new Error(result.description || 'Das Produkt konnte nicht hinzugefügt werden.');
          }

          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(result);
          } else if (result.sections) {
            Object.entries(result.sections).forEach(([sectionId, html]) => {
              const target = document.getElementById(`shopify-section-${sectionId}`);
              if (!target || !html) return;
              const parsed = new DOMParser().parseFromString(html, 'text/html');
              const source = parsed.getElementById(`shopify-section-${sectionId}`);
              target.innerHTML = source ? source.innerHTML : html;
            });
            document.querySelector('cart-drawer')?.open?.();
          }
        } catch (error) {
          mobileAdd.textContent = 'Erneut versuchen';
          window.setTimeout(() => {
            mobileAdd.textContent = originalLabel;
          }, 2200);
        } finally {
          mobileAdd.disabled = false;
        }
      });
    }

    const videoArea = section.querySelector('[data-vp-video-section]');
    if (videoArea) {
      const player = videoArea.querySelector('[data-vp-main-video]');
      const choices = videoArea.querySelectorAll('[data-vp-video-src]');
      const count = videoArea.querySelector('[data-vp-video-count]');
      const title = videoArea.querySelector('[data-vp-video-title]');
      const copy = videoArea.querySelector('[data-vp-video-copy]');

      choices.forEach((choice, index) => {
        choice.addEventListener('click', () => {
          const source = choice.dataset.vpVideoSrc;
          choices.forEach((item) => {
            const isActive = item === choice;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          if (player.getAttribute('src') !== source) {
            player.pause();
            player.setAttribute('src', source);
            player.setAttribute('poster', choice.dataset.vpVideoPoster);
            player.setAttribute('aria-label', choice.dataset.vpVideoLabel);
            player.load();
          }
          count.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(choices.length).padStart(2, '0');
          title.textContent = choice.dataset.vpVideoTitle;
          copy.textContent = choice.dataset.vpVideoCopy;
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
